import { render, staticRenderFns } from "./waitDelivery.vue?vue&type=template&id=31958ad8&scoped=true"
import script from "./waitDelivery.vue?vue&type=script&lang=js"
export * from "./waitDelivery.vue?vue&type=script&lang=js"
import style0 from "./waitDelivery.vue?vue&type=style&index=0&id=31958ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31958ad8",
  null
  
)

export default component.exports